export default __webpack_public_path__ + "static/media/companies-logo.c8d16210.svg";